import Axios from 'axios'
import { takeLatest, put, select, call } from 'redux-saga/effects'

import {
  COMPLIANCE_GET_POSTS_ATTEMPT,
  COMPLIANCE_GET_UPDATES_ATTEMPT
} from './actionTypes'
import { primaryFormat } from '../account/selectors'
import { api } from '../common/helpers'
import {
  getPostsFailure,
  getPostsSuccess,
  setUpdates
} from './actions'

function* getPostsData() {
  try {
    const axiosReturn = yield call(Axios, {
      baseURL: API_BASE_PATH,
      url: `/posts-feed-proxy?tags=892&_T=${new Date().getTime()}`,
      method: 'get',
      responseType: 'json'
    })

    if (axiosReturn.data.length === 0) {
      yield put(getPostsFailure('No Posts'))
    } else {
      yield put(getPostsSuccess(axiosReturn.data))
    }
  } catch (error) {
    console.log('There\'s been an error calling Posts API', error)
    yield put(getPostsFailure('Error getting posts'))
  }
}

function* getUpdatesData() {
  const apiResponse = yield api({
    api: '/postings/updates',
    params: {
      pageNumber: 1,
      pageSize: 999999
    }
  })
  if (!apiResponse.error) {
    yield put(setUpdates(apiResponse.data.updates))
  }
}

export default function* complianceSaga() {
  yield takeLatest(COMPLIANCE_GET_POSTS_ATTEMPT, getPostsData)
  yield takeLatest(COMPLIANCE_GET_UPDATES_ATTEMPT, getUpdatesData)
}
